import wrapSecureClientInterface from './interface-wrapper';

export default wrapSecureClientInterface;
